import React from 'react'
import styled from 'styled-components'
import { TimeAgo } from '@sketch/components'
import {
  ImageWrapper,
  TableWrapper,
  Name,
  TableCell,
  NameWrapper,
} from '../DocumentItem/DocumentItem.styles'
import { ProjectTrashItemProps, getButtonProps, renderDropdown } from './utils'
import { handleTimeFormat } from '../DocumentItem'
import { StyledStatusIcon } from './ProjectTrashItem.styles'
import { ReactComponent as FolderIcon } from '@sketch/icons/folder-closed-16-svg'

// This is the list item for the project in trash. It shares a bunch of
// functionalities with the grid item and those functions belongs to the
// This is will be addressed on a separate PR -> https://github.com/sketch-hq/Cloud/issues/10307
export const ProjectTrashItemListView = styled(
  function ProjectTrashItemListView(props: ProjectTrashItemProps) {
    const { className, name, deletedAt, renderDropdownItems, onClick } = props

    const dropdownContent = renderDropdownItems?.()

    const a11yProps = onClick ? getButtonProps(onClick) : {}

    return (
      <TableWrapper className={className} title={name} {...a11yProps}>
        <TableCell>
          <NameWrapper>
            <ImageWrapper title={name}>
              <StyledStatusIcon
                as={FolderIcon}
                aria-label={`Project ${name}`}
              />
            </ImageWrapper>
            <Name>{name}</Name>
          </NameWrapper>
        </TableCell>
        <TableCell>{'—'}</TableCell>
        <TableCell>
          <div className="keep-size">
            <TimeAgo date={deletedAt} formatter={handleTimeFormat} />
          </div>
        </TableCell>
        <TableCell>{'—'}</TableCell>
        <TableCell>
          {dropdownContent && renderDropdown(dropdownContent)}
        </TableCell>
      </TableWrapper>
    )
  }
)``
